import React from 'react';
import { Box, Typography } from '@material-ui/core';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import classes from './ToolbarPlaceholder.module.scss';

const ToolbarPlaceholder = () => {
  return (
    <Box className={classes.toolbarPlaceholder}>
      <WbIncandescentIcon />
      <Typography>You can restore files within 30 days of deletion</Typography>
    </Box>
  );
};

export default ToolbarPlaceholder;
